/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessPeriod
 */
export interface BusinessPeriod {
    /**
     * 
     * @type {string}
     * @memberof BusinessPeriod
     */
    timeStart: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessPeriod
     */
    timeEnd: string;
}

/**
 * Check if a given object implements the BusinessPeriod interface.
 */
export function instanceOfBusinessPeriod(value: object): value is BusinessPeriod {
    if (!('timeStart' in value) || value['timeStart'] === undefined) return false;
    if (!('timeEnd' in value) || value['timeEnd'] === undefined) return false;
    return true;
}

export function BusinessPeriodFromJSON(json: any): BusinessPeriod {
    return BusinessPeriodFromJSONTyped(json, false);
}

export function BusinessPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'timeStart': json['timeStart'],
        'timeEnd': json['timeEnd'],
    };
}

export function BusinessPeriodToJSON(json: any): BusinessPeriod {
    return BusinessPeriodToJSONTyped(json, false);
}

export function BusinessPeriodToJSONTyped(value?: BusinessPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeStart': value['timeStart'],
        'timeEnd': value['timeEnd'],
    };
}

